import { create } from "zustand";
import { persist } from "zustand/middleware";

type LogboekLaatstGelezenItem = { dossierNummer: string; laatstGelezenDatumTijd: Date };

type LogStore = {
    markAsLaatstGelezen: (dossierNummer: string) => void;
    laatstGelezen: LogboekLaatstGelezenItem[];
};

export const useLogboekStore = create<LogStore>()(
    persist(
        (set, get) => ({
            laatstGelezen: [],
            markAsLaatstGelezen: (dossierNummer: string) => {
                const current = get().laatstGelezen.find((item) => item.dossierNummer === dossierNummer);

                if (!current) {
                    set((state) => ({
                        laatstGelezen: [...state.laatstGelezen, { dossierNummer, laatstGelezenDatumTijd: new Date() }],
                    }));
                } else {
                    set((state) => ({
                        laatstGelezen: state.laatstGelezen.map((item) =>
                            item.dossierNummer === dossierNummer ? { ...item, laatstGelezenDatumTijd: new Date() } : item
                        ),
                    }));
                }
            },
        }),
        {
            name: "logboek-gelezen-status",
        }
    )
);
